<template>
  <div class="overflow-hidden w-ful h-full">
    <component :is="ComponentListKapal" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TableListKapal from './TableListKapal.vue'
import FilterListKapal from './FilterListKapal.vue'

export default {
  name: 'MenuListKapal',
  computed: {
    ...mapGetters(['activeSubMenu']),
    ComponentListKapal: function () {
      if (this.activeSubMenu === 'ListKapal') return TableListKapal
      if (this.activeSubMenu === 'FilterListKapal') return FilterListKapal

      return TableListKapal
    }
  }
}
</script>
